import { render, staticRenderFns } from "./thumb-autoupdate.vue?vue&type=template&id=cf00ff90"
import script from "./thumb-autoupdate.vue?vue&type=script&lang=js"
export * from "./thumb-autoupdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports